export enum DataLayerEvents {
  Loaded = 'dataLayer-loaded',
  MemberLoaded = 'dataLayer-memberLoaded',
  LeadLoaded = 'dataLayer-leadLoaded',
  OptimizeActivate = 'optimize.activate'
}
